<template>
  <div class="p-4">
    <div class="mb-6">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Название технологии:</label>
        <textarea
          v-model="technologyName"
          rows="2"
          maxlength="255"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Введите название технологии"
        />
      </div>
      
      <div class="mt-6">
        <div class="flex justify-between items-center mb-2">
          <h3 class="text-lg font-semibold">Операции</h3>
        </div>
        
        <div v-if="!sortedOperations || sortedOperations.length === 0" class="bg-gray-100 p-4 text-center text-gray-500 rounded">
          Для этой технологии ещё не добавлены операции
        </div>
        
        <div v-else>
          <transition-group
            name="operation-list"
            tag="div"
          >
            <div
              v-for="(operation, index) in sortedOperations"
              :key="operation.id"
              class="mb-4 border rounded-md shadow-sm overflow-hidden"
            >
              <div class="bg-gray-50 p-3 flex justify-between items-center border-b">
                <button
                  @click="$emit('viewDetail', operation.id, data.technology.id)"
                  class="text-sm font-medium text-blue-600 text-left"
                >
                  {{ index + 1 }}. {{ operation.name }}
                </button>
                <div class="flex items-center space-x-1">
                  <button
                    @click="$emit('moveOperationUp', operation.id, data.technology.id)"
                    class="text-blue-600 hover:text-blue-800 p-1"
                    :disabled="index === 0"
                    :class="{'opacity-50 cursor-not-allowed': index === 0}"
                  >
                    ↑
                  </button>
                  <button
                    @click="$emit('moveOperationDown', operation.id, data.technology.id)"
                    class="text-blue-600 hover:text-blue-800 p-1"
                    :disabled="index === sortedOperations.length - 1"
                    :class="{'opacity-50 cursor-not-allowed': index === sortedOperations.length - 1}"
                  >
                    ↓
                  </button>
                  <DeleteButton :title="'операцию'" @click="confirmDeleteOperation(operation)" />
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    
    <!-- Модальное окно подтверждения удаления операции -->
    <div v-if="showDeleteConfirm" class="fixed inset-0 z-10 bg-black bg-opacity-50 flex items-center justify-center">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-md">
        <h3 class="text-lg font-semibold mb-4">Подтверждение удаления</h3>
        <p class="mb-4">Вы уверены, что хотите удалить операцию "{{ operationToDelete?.name }}"?</p>
        <div class="flex justify-end space-x-2">
          <button
            @click="cancelDelete"
            class="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
          >
            Отмена
          </button>
          <button
            @click="deleteOperation"
            class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeleteButton from "@/components/DeleteButton.vue";

export default {
  components: { DeleteButton },
  props: ['data'],
  data() {
    return {
      showDeleteConfirm: false,
      operationToDelete: null
    };
  },
  computed: {
    sortedOperations() {
      if (!this.data.technology.operations) {
        return [];
      }
      return [...this.data.technology.operations].sort((a, b) => (a.sort || 0) - (b.sort || 0));
    },
    
    technologyName: {
      get() {
        return this.data.technology.name;
      },
      set(value) {
        if (this.data.technology) {
          this.data.technology.name = value.trim();
          this.$emit('change');
        }
      }
    }
  },
  watch: {
    // Следим за изменениями в операциях технологии
    'data.technology.operations': {
      handler(newOperations) {
        if (newOperations) {
          // При изменении операций, обновляем их сортировку
          this.$nextTick(() => {
            // Для отладки выводим информацию об операциях
            console.log('Операции обновлены:', newOperations.map(op => ({
              id: op.id,
              name: op.name,
              sort: op.sort
            })));
            
            // Принудительно обновляем компонент
            this.$forceUpdate();
          });
        }
      },
      deep: true // Отслеживаем глубокие изменения в массиве
    },
    
    // Также следим за изменениями в самой технологии
    'data.technology': {
      handler(newTechnology) {
        if (newTechnology && newTechnology.operations) {
          console.log('Технология обновлена:', {
            id: newTechnology.id,
            name: newTechnology.name,
            operationsCount: newTechnology.operations.length
          });
          
          // Обновляем компонент
          this.$forceUpdate();
        }
      },
      deep: true
    }
  },
  methods: {
    confirmDeleteOperation(operation) {
      this.operationToDelete = operation;
      this.showDeleteConfirm = true;
    },
    
    cancelDelete() {
      this.showDeleteConfirm = false;
      this.operationToDelete = null;
    },
    
    deleteOperation() {
      if (this.operationToDelete) {
        this.$emit('removeOperation', this.operationToDelete.id, this.data.technology.id);
        this.showDeleteConfirm = false;
        this.operationToDelete = null;
      }
    }
  }
};
</script>

<style scoped>
.operation-list-move {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.operation-list-enter-active,
.operation-list-leave-active {
  transition: all 0.2s ease;
}

.operation-list-enter-from,
.operation-list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
